<template>
    <div class="journey-planner">

        <h1>Journey Planner</h1>

        <div class="row">
            <div class="col-md-6">

                <gmap-map ref="gmap"
                          :center="{lat: latitude, lng: longitude}"
                          :zoom="11"
                          style="width: 800px; height: 600px; max-width: 100%;"
                >
                    <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        :clickable="true"
                        :draggable="false"
                        @click="addAddress(m)"
                    />
                </gmap-map>

            </div>
            <div class="col-md-6">
                <h2>Destinations</h2>
                <ul class="waypoints">
                    <li v-for="m in addresses">
                        <a href="#" class="remove" @click.prevent="removeAddress(m)">Remove</a>
                        <h4>{{m.company.company_name}}</h4>
                        <p>{{m.company.full}}</p>

                    </li>
                </ul>
            </div>
        </div>

        <hr />

        <div class="excluded-companies">
            <h2>Not all companies are listed on the map above:</h2>

            <ul>
                <li v-for="company in companies" v-if="!companyVisible(company)">
                    <h6>{{company.company_name}}</h6>
                    <p>Address: {{company.full}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from "vue"
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_API_GMAPS_KEY,
        libraries: 'geocoder'
    }
});

export default {
  name: "journey_planner",
    data: function () {
        return {
            geocode: true,
            latitude: 50.82194564655835,
            longitude: -1.0747858825313292,
            locations: [],

            companies: [],

            geocoder : null,
            markers : [],
            addresses : []
        }
    },
    created() {
      let self = this;

        axios.get(this.crmApiPath + 'company/all/planner').then(companies => {
            self.companies = companies.data

            self.$gmapApiPromiseLazy().then(() => {
                self.geocoder = new google.maps.Geocoder();

                for(let i = 0; i < self.companies.length; i++) {
                    if(this.geocode) {
                        self.updateLatLng(self.companies[i]);
                    }
                    self.addMarker(self.companies[i]);
                }
            })

        }).catch(error => console.log(error.response));
    },
    methods: {
        companyVisible(company) {
          if(company.lat && company.lng) {
              return true;
          }

          return false;
        },
        updateLatLng(company) {

            let self = this;

            if(
                company.addresses_id !== null && // Must have an address ID
                company.full !== null && // Must have an address field
                (company.lat === null || company.lng === null) // Must have either value as null
            ) {

                // console.log('--------------------');
                // console.log(company.addresses_id !== null);
                // console.log(company.full !== null);
                // console.log(company.lat === null || company.lng === null);
                // console.log(company);
                // console.log('--------------------');

                this.geocoder.geocode( { 'address': company.full}, function(results, status) {

                    if (status == google.maps.GeocoderStatus.OK) {
                        let lat = results[0].geometry.location.lat();
                        let lng = results[0].geometry.location.lng();

                        axios.post(self.crmApiPath + 'company/all/geocode', {
                            id: company.addresses_id,
                            lat: lat,
                            lng: lng

                        }).then(result => {
                            company.lat = lat;
                            company.lng = lng;
                        })
                    } else {
                        console.log('Error: ' + status);
                    }

                });
            }
        },
        addMarker(company) {
            if(company.lat !== null && company.lng !== null) {
                this.markers.push(
                    {
                        company: company,
                        position: {lat: parseFloat(company.lat), lng: parseFloat(company.lng)}
                    }
                );
            }
        },
        isReady() {
            return (this.geocoder !== null);
        },
        addAddress (marker) {
            this.addresses.push(marker);
        },
        removeAddress(m) {
            let i = this.addresses.indexOf(m);
            this.addresses.splice(i, 1);
        }
    }
}
</script>
